var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"render"},[(!_vm.$store.getters['user/getUserFields'].is_admin)?_c('div',[_vm._v(" Вы не администратор, авторизируйтесь как администратор! ")]):_c('div',{staticClass:"content_table"},[_vm._m(0),_c('FilterMy',{attrs:{"visible":{
       date: true,
       phone: true,
       calls: _vm.users,
       callsMultiple: false,
       scripts: false,
       text: false,
       nickname: false,
       visible: false,
       target: false,
       managerVisible: false,
       maska: '+7 (###) ###-##-##'
     },"calls-title":"Пользователь","calls-placeholder":"Выберите","emptyRangeText":"Выберите дату"},on:{"updateFilter":_vm.onFilterChange,"exportExcel":_vm.onExport}}),_c('Table',{attrs:{"page_type":'verification_calls',"items":[],"loading":_vm.loading,"perPage":_vm.perPage,"server":false,"hideselect":true,"headers":_vm.table.headers,"data":_vm.table.data,"sortedBy":{ value: 'created_at', order: 'desc' }}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('h1',[_vm._v("Звонки с кодом подтверждения")])])
}]

export { render, staticRenderFns }